// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.6,22v-9.1h3.1l0.5-3.6h-3.5V7.1c0-1,0.3-1.7,1.8-1.7h1.9V2.1C16.3,2,15.4,2,14.4,2c-2.7,0-4.6,1.7-4.6,4.7v2.6H6.8v3.6h3.1V22H13.6z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-facebook-D4eNOYV-.js.map
